import http from "../../../helpers/http";

export const GetFinesListByCarPlate = async (
  CarPlate: string,
): Promise<any> => {
  const { data } = await http.get<any>(
    `fines/search?placa=${CarPlate}`,
  );
  

  // Manejo de errores devueltos por el backend
  if (data.error) {
    return { error: data.error }; // Retornamos el error directamente
  }
  
  return data;
};

export const startPayment = async (order: string): Promise<any> => {
  const { data } = await http.patch<any>(
    `fines/start-payment`, 
    { order } // Pasar el `order` en el cuerpo de la petici�n
  );
  
  return data;
};

export const downloadXML = async (order: string): Promise<any> => {
  const { data } = await http.get<any>(`fines/download-timbrado/${order}/xml`);
  return data;
};

export const downloadPDF = async (order: string): Promise<Blob> => {
  const { data } = await http.get<Blob>(`fines/download-timbrado/${order}/pdf`, {
    responseType: "blob", 
  });
  return data;
};

export const downloadZip = async(order:string): Promise<any> => {
  const { data } = await http.get<any>(`fines/download-timbrado/${order}/all`);
  return data;
}